import React, { useState } from 'react';
import * as Icons from "react-icons/tb";

const Modal = ({ isOpen, onClose, children }) => {
  const modalClass = isOpen ? 'modal-container open' : 'modal-container'; // CSS class for showing/hiding modal
  const overlayClass = isOpen ? 'overlay open' : 'overlay'; // CSS class for showing/hiding overlay

  return (
    <div className={overlayClass}>
      <div className={modalClass}>
        <button className="close-button" onClick={onClose}>
          <Icons.TbX/>
        </button>
        {children}
      </div>
    </div>
  );
};

export default Modal;
